/**
 * Returns the plural form of a word if the count is not 1.
 */
export const pluralize = (count, text, plural) => {
    if (count === 1) {
        return text;
    }
    if (plural) {
        return plural;
    }
    if (text.endsWith('s')) {
        return `${text}es`;
    }
    return `${text}s`;
};
//# sourceMappingURL=pluralize.js.map